module.exports = __webpack_public_path__ + "static/img/11-1.cc72438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11-1.jpg
// module id = fu5M
// module chunks = 0